import React from 'react';
import {Container, Title, Subtitle, Description, ActionButton, Wrapper, HeroContent} from './styled';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const Hero = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const handleAction = () => {
    isLoggedIn ? navigate('/dashboard') : navigate('/signup');
  }

  return (
    <Container>
      <Wrapper>
        <HeroContent>
          <Title>Fusion Cost Model</Title>
          <Subtitle>Understanding fusion economics to guide innovation and investment</Subtitle>
          <Description>
            The <strong>Fusion Cost Model</strong> is a first-of-its-kind app for analyzing the cost structure of commercial fusion power plants. It offers a transparent platform to explore cost drivers, test different configurations, and evaluate the tradeoffs between financial and technical aspects of fusion power plants.
          </Description>
          <ActionButton onClick={handleAction}>
            Explore the Tool
          </ActionButton>
        </HeroContent>
      </Wrapper>
    </Container>
  );
}

export default Hero;
